var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaultSecureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4082 1.87109L14.125 4.28418L17.8428 6.19629L18.25 6.40625V7.71973C18.25 12.6806 15.2599 17.1345 10.708 19.0273L10.2627 19.2021C10.1355 19.2493 9.99908 19.2609 9.86719 19.2373L9.7373 19.2021C4.93627 17.4209 1.75 12.8405 1.75 7.71973V6.40625L5.87402 4.28418L9.5918 1.87109L10 1.60547L10.4082 1.87109ZM6.6582 5.56348L6.62695 5.58398L3.25 7.32031V7.71973C3.25 12.1203 5.93222 16.0639 10 17.6934C14.0678 16.0639 16.75 12.1203 16.75 7.71973V7.32031L13.373 5.58398L13.3418 5.56348L10 3.39355L6.6582 5.56348ZM13.7158 8.99023L9.3916 13.3174L6.96191 10.8877L8.02148 9.82812L9.3916 11.1963L12.6543 7.93066L13.7158 8.99023Z",
    fill: "#1A1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultSecureIcon);
export default __webpack_public_path__ + "static/media/vault-secure-icon.831a04f5d9328855116c2298e73f974e.svg";
export { ForwardRef as ReactComponent };